import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
Vue.use(Router)

var components = [
  // 'index',
  // 'statics',
  // 'assets',
  // 'system',
  // 'resource',
  // 'maintance',
  // 'alarm',
  'alarmstatistics',
  'dataQuery',
  // 'security',
  // 'problem',
  // 'worksheet',
  // 'digitalIndex',
  'queryTools',
  'diagnose',
  'malf',
  'chatbot',
  'mycare',
  // 'version',
  // 'repair',
  // 'remote',
  // 'superset',
  'knowledge',
  'knowledgeGraph',
  'rootCause',
  'dmp'
]

var routers = []
for (let comp of components) {
  var rs = require('../views/' + comp + '/router.js')
  routers = routers.concat(rs.router)
}
console.info(routers);
store.state.views = routers

// 获取当前环境development或production
var env = process.env.NODE_ENV
console.log("env:--" + env);
// 定义Router中的变量
var routermode = 'hash'
var routerbase = '/'
// 开始判断当前是开发环境还是测试环境
if (env == "production") {
  routermode = 'history'
  routerbase = 'dataanalyse'
} else if (env == "development") {
  routermode = 'hash'
  routerbase = '/'
}

export default new Router({
  mode: routermode,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  base: routerbase,
  routes: [
    {
      path: '',
      name: 'Login',
      redirect: '/knowledgeGraph'
    },
    {
      path: '/',
      name: 'Framework',
      component: resolve => require(["@/views/Framework"], resolve),
      children: routers
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js